import { RootState } from '@store/store.interface';

const getState = (state: RootState) => state.athleteRoles;
export const athleteRolesSelector = (state: RootState) => getState(state).data;
export const athleteRolesIsLoadingSelector = (state: RootState) => getState(state).isLoading;
export const athleteRolesIsReadySelector = (state: RootState) => getState(state).isReady;
export const athleteRolesErrorSelector = (state: RootState) => getState(state).error;
